// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Step2_wrapper__zlGmD","info":"Step2_info__mxWGX"};